import { useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useCartButton } from "../../../OrderFlow/components/Cart/useCartButton";
import { ORDER_STATUS } from "../../../Shared/utils/constants";
export const useMyMealsCartButton = ({ showQuickSaveButton, saveAndUpdateText, saveAndUpdateCart, saveAndUpdateFutureOrder, selectedFutureOrder, selectedOrder, subtotal, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const { usesCustomCartIcon, isCustomCartIconWhite, customCartIconUrl } = useCartButton();
    const [loading, setLoading] = useState(true);
    // Controls the visibility and fade action of the quick save button.
    const [shouldFade, setShouldFade] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    // Fade in and out the quick save button on desktop and the background,
    // box shadows, and quick save button on mobile.
    useEffect(() => {
        let fadeInTimer;
        let fadeOutTimer;
        if (showQuickSaveButton) {
            setIsVisible(true);
            fadeInTimer = setTimeout(() => {
                setShouldFade(true);
            }, 50);
        }
        else {
            setShouldFade(false);
            fadeOutTimer = setTimeout(() => {
                setIsVisible(false);
            }, 1000);
        }
        return () => {
            clearTimeout(fadeInTimer);
            clearTimeout(fadeOutTimer);
        };
    }, [showQuickSaveButton]);
    useEffect(() => {
        const image = new Image();
        image.src = customCartIconUrl;
        image.onload = () => {
            setLoading(false);
        };
        // Handle image loading error if needed
        image.onerror = () => {
            setLoading(false);
        };
    }, [customCartIconUrl]);
    const showUpdatedCost = subtotal !== 0 &&
        selectedFutureOrder === null &&
        (selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.OrderStatus) !== ORDER_STATUS.FUTURE &&
        (selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.OrderStatus) !== ORDER_STATUS.PENDING;
    const btnConditionals = selectedFutureOrder == null && (selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.OrderStatus) !== ORDER_STATUS.FUTURE;
    const btnText = btnConditionals ? saveAndUpdateText : "Save Changes";
    const btnOnClick = btnConditionals ? saveAndUpdateCart : saveAndUpdateFutureOrder;
    return {
        btnOnClick,
        btnText,
        usesCustomCartIcon,
        customCartIconUrl,
        isCustomCartIconWhite,
        isMobile,
        isVisible,
        loading,
        shouldFade,
        showUpdatedCost,
    };
};
